// extracted by mini-css-extract-plugin
export default {"auth":"SignIn_auth__56HBA","auth__title":"SignIn_auth__title__dqK5B"};